/**
 * HTTP request payload for executing WIQL queries. Defaults to searching for user stories in primary project.
 * @type {object}
 */
export const POST_WIQL = {
	query:
		`Select [System.Id] From WorkItems Where [System.WorkItemType] IN ('User Story', 'Bug')` +
		`AND [System.TeamProject] = 'Identity Management System'`,
};